/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { BaseRequestConfig } from '../../framework/BaseRequestConfig';
import { AuthenticationJson } from '../json/JsonAll';
import { UserEditJson } from '../json/JsonAll';
import { NoticeListJson } from '../json/JsonAll';
import { AccessTransitionJson } from '../json/JsonAll';
import { RankJson } from '../json/JsonAll';
import { NoticeCriteriaJson } from '../json/JsonAll';
import { Net } from '../../common/extends_fw/Net';

export class DashboardApi {
    /**
     * Base Pathの設定。デフォルトは「/」
     */
    protected basePath: string = '/';

    /**
     * コンストラクタ
     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
     * @param { string } basePath ベースパスを設定する
     */
    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService, protected $httpParamSerializer: ng.IHttpParamSerializer, basePath: string, protected $net: Net) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    /**
     * お知らせの情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public getNotice(criteria: NoticeCriteriaJson,
                isDbl: boolean = true): ng.IHttpPromise<NoticeListJson[]> {
        return this.$net.get('/notices/search', criteria);
    }

    /**
     * アクセス数を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public getAccess(
                isDbl: boolean = true): ng.IHttpPromise<AccessTransitionJson> {
        return this.$net.get('/rankings/accsesHistory', null);
    }

    /**
     * お知らせの情報を取得する。
     * @param authorCode  著者コード
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public getRanking(id: string,
                isDbl: boolean = true): ng.IHttpPromise<RankJson[]> {
        if (id === '1') {
            return this.$net.get('/rankings/count', null);
        } else if (id === '2') {
            return this.$net.get('/rankings/bookmark', null);
        } else if (id === '3') {
            return this.$net.get('/rankings/evaluation', null);
        }
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/api/DashboardApi.ts
 **/